import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles//AuthStyles.css';
import { register } from '../services/auth';


const SuccessAlert = ({ message }) => (
    <div 
        className="success-alert"
    >
        <div className="success-alert-content">
            <span className="success-icon">✓</span>
            <p>{message}</p>
        </div>
    </div>
);
const Register = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        confirmPassword: '',
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [registrationMessage, setRegistrationMessage] = useState('');
    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.firstName.trim()) {
            newErrors.firstName = 'First name is required';
        }
        
        if (!formData.lastName.trim()) {
            newErrors.lastName = 'Last name is required';
        }
        
        if (!formData.email) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        
        if (!formData.password) {
            newErrors.password = 'Password is required';
        } else if (formData.password.length < 8) {
            newErrors.password = 'Password must be at least 8 characters';
        } else if (!/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/.test(formData.password)) {
            newErrors.password = 'Password must contain at least one uppercase letter, one lowercase letter, and one number';
        }
        
        if (formData.password !== formData.confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!validateForm()) return;
        
        setIsLoading(true);
        try {
            const message = await register(formData);
            setRegistrationMessage(message);
            if(message) {
                setShowSuccess(true);
                await new Promise(resolve => setTimeout(resolve, 3000));
                setShowSuccess(true);
                navigate('/');
            }
        } catch (error) {
            setErrors({
                submit: error.message || 'Registration failed. Please try again.'
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <h1>Create account</h1>
                    {errors.submit && <div className="error-text">{errors.submit}</div>}
                    
                    {/* <p>to get started</p> */}
                </div>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            name="firstName"
                            className="form-control"
                            placeholder=" "
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                        <label className="form-label">First name</label>
                        {errors.firstName && <div className="error-text">{errors.firstName}</div>}
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="text"
                            name="lastName"
                            className="form-control"
                            placeholder=" "
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                        <label className="form-label">Last name</label>
                        {errors.lastName && <div className="error-text">{errors.lastName}</div>}
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder=" "
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <label className="form-label">Email</label>
                        {errors.email && <div className="error-text">{errors.email}</div>}
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="password"
                            name="password"
                            className="form-control"
                            placeholder=" "
                            value={formData.password}
                            onChange={handleChange}
                        />
                        <label className="form-label">Password</label>
                        {errors.password && <div className="error-text">{errors.password}</div>}
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="password"
                            name="confirmPassword"
                            className="form-control"
                            placeholder=" "
                            value={formData.confirmPassword}
                            onChange={handleChange}
                        />
                        <label className="form-label">Confirm password</label>
                        {errors.confirmPassword && <div className="error-text">{errors.confirmPassword}</div>}
                    </div>

                    <button 
                        type="submit" 
                        className="auth-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Creating account...' : 'Create account'}
                    </button>
                </form>
                
                <div className="auth-links">
                    <a href="/" className="auth-link">Already have an account? Sign in</a>
                </div>
            </div>
            {showSuccess && (
                <SuccessAlert message={registrationMessage} />
            )}
        </div>
    );
};

export default Register;